import {useLayoutEffect, useMemo, useState} from 'react';

class Accordion {
    constructor(
        initialOpen: boolean,
        duration: number,
        private readonly container: HTMLElement,
        private readonly content: HTMLElement
    ) {
        this.container.style.overflow = 'hidden';
        this.container.style.transition = `height ${duration}ms ease-in-out`;
        this.container.style.height = initialOpen ? `${this.container.scrollHeight}px` : '0px';
    }

    shrink() {
        this.container.style.height = '0px';
    }

    expand() {
        this.container.style.height = `${this.content.scrollHeight}px`;
    }
}

export function useAccordion(open: boolean, duration: number = 200) {
    const [containerEl, setContainerEl] = useState<null | HTMLElement>(null);
    const [contentEl, setContentEl] = useState<null | HTMLElement>(null);

    const accordion = useMemo(() => {
        if (containerEl && containerEl && contentEl) {
            return new Accordion(open, duration, containerEl, containerEl);
        }
    }, [containerEl, contentEl]);

    useLayoutEffect(() => {
        if (!accordion) return;
        if (open) {
            accordion.expand();
        } else {
            accordion.shrink();
        }
    }, [open]);

    return {containerRef: setContainerEl, contentRef: setContentEl};
}
